@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';

/* Primary and base styling */
.button {
  @include barlowMedium(16);
  background-color: _palette(primary);
  border: 0;
  border-radius: 3px;
  box-shadow:
    0 0 2px 0 rgba(0, 0, 0, 0.12),
    0 2px 2px 0 rgba(0, 0, 0, 0.24);
  color: white;
  cursor: pointer;
  height: 2.375rem;
  min-width: 9.5rem;
  outline: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;

  & * {
    vertical-align: middle;
  }

  &.button:hover {
    background-color: _palette(primary-dark);
  }

  &.button:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(primary);
    box-shadow:
      0 0 4px 0 rgba(114, 30, 127, 0.12),
      0 8px 8px 0 rgba(114, 30, 127, 0.24);
    color: #3f0f46;
  }

  &.button:disabled,
  &.button[disabled] {
    background-color: _palette(bg-primary-dark);
    box-shadow: none;
    color: _palette(text-secondary);
    pointer-events: none;
  }

  &.button:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(primary);
    box-shadow: none;
    color: _palette(primary-dark);
    outline: 0;
  }

  &.leftsplit {
    border-radius: 0 3px 3px 0;
  }

  &.leftsplit:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(primary);
    box-shadow:
      0 0 4px 0 rgba(114, 30, 127, 0.12),
      0 8px 8px 0 rgba(114, 30, 127, 0.24);
    color: _palette(primary);
    outline: none;
  }

  &.leftsplit:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(primary);
    box-shadow: none;
    color: _palette(primary);
    outline: none;
    z-index: 50;
  }

  &.rightsplit,
  &.rightsplitOpened {
    border-left: 0.0625rem solid rgba(255, 255, 255, 0.25);
    border-radius: 0 3px 3px 0;
    min-width: 2.25rem;
    outline: 0;
    padding-left: 0;
    padding-right: 0;
  }

  &.rightsplitOpened {
    background-color: _palette(bg-secondary);
  }

  &.rightsplit:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(primary);
    color: _palette(primary-dark);
    outline: 0;
  }

  &.rightsplit:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(primary);
    box-shadow:
      0 0 4px 0 rgba(114, 30, 127, 0.12),
      0 8px 8px 0 rgba(114, 30, 127, 0.24);
    outline: none;
  }

  /* Secondary */

  &.secondary {
    background-color: _palette(secondary);
    color: _palette(bg-secondary);

    &.leftsplit:focus {
      background-color: _palette(
        bg-secondary
      ); // Må endres når design er bestemt
      border: 0.125rem solid _palette(secondary);
      box-shadow:
        0 0 4px 0 rgba(15, 106, 136, 0.12),
        0 8px 8px 0 rgba(15, 106, 136, 0.24);
      outline: none;
    }

    &.leftsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(secondary);
      box-shadow: none;
      color: _palette(secondary);
    }

    &.rightsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(secondary);
      box-shadow: none;
      color: _palette(secondary);
      outline: none;
    }

    &.rightsplit:focus {
      background-color: _palette(bg-secondary);
      border: 0.125rem solid _palette(secondary);
      box-shadow:
        0 0 4px 0 rgba(15, 106, 136, 0.12),
        0 8px 8px 0 rgba(15, 106, 136, 0.24);
      outline: none;
    }

    &:hover {
      background-color: _palette(secondary-dark);
      color: _palette(bg-secondary);
    }
  }

  &.secondary:focus {
    background-color: _palette(bg-secondary);
    color: _palette(secondary);
  }

  &.secondary:disabled,
  &.secondary[disabled] {
    background-color: _palette(bg-primary-dark);
    color: _palette(text-secondary);
  }

  &.secondary:disabled:hover,
  &.secondary[disabled]:hover {
    background-color: #b0bdbd;
    color: _palette(bg-secondary);
  }

  &.secondary:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(secondary);
    box-shadow: none;
    color: _palette(secondary-dark);
  }

  //Tertiary
  &.tertiary {
    background-color: _palette(bg-secondary);
    color: _palette(primary);

    &.leftsplit:focus {
      background-color: _palette(
        bg-secondary
      ); // Må endres når design er bestemt
      border: 0.125rem solid _palette(primary);
      box-shadow:
        0 0 4px 0 rgba(114, 30, 127, 0.12),
        0 8px 8px 0 rgba(114, 30, 127, 0.24);
      color: _palette(primary-dark);
      outline: none;
    }

    &.leftsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(primary-dark);
      box-shadow: none;
      color: _palette(primary-dark);
    }

    &.rightsplit,
    &.rightsplitOpened {
      border-left: 0.0625rem solid _palette(primary);
      border-radius: 0 3px 3px 0;
      min-width: 2.25rem;
      outline: 0;
      padding-left: 0;
      padding-right: 0;
    }

    &.rightsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(primary-dark);
      color: _palette(primary-dark);
      outline: none;
    }

    &.rightsplit:focus {
      background-color: _palette(
        bg-secondary
      ); // Må endres når design er bestemt
      border: 0.125rem solid _palette(primary-dark);
      box-shadow:
        0 0 4px 0 rgba(114, 30, 127, 0.12),
        0 8px 8px 0 rgba(114, 30, 127, 0.24);
      outline: none;
    }

    &:hover {
      background-color: rgba(114, 30, 127, 0.15);
      color: _palette(primary);
    }
  }

  &.tertiary:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(primary);
    box-shadow:
      0 0 4px 0 rgba(114, 30, 127, 0.12),
      0 8px 8px 0 rgba(114, 30, 127, 0.24);
    outline: none;
  }

  &.secondary:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(secondary);
    box-shadow:
      0 0 4px 0 rgba(15, 106, 136, 0.12),
      0 8px 8px 0 rgba(15, 106, 136, 0.24);
    outline: none;
  }

  &.secondary:active {
    border: 0.0625rem solid _palette(secondary-dark);
    box-shadow: none;
  }

  &.tertiary:focus {
    background-color: _palette(bg-secondary);
    color: _palette(primary);
  }

  &.tertiary:disabled,
  &.tertiary[disabled] {
    background-color: _palette(bg-primary-dark);
    color: rgba(0, 0, 0, 0.5);
  }

  &.tertiary:disabled:hover,
  &.tertiary[disabled]:hover {
    background-color: #b0bdbd;
    color: _palette(bg-secondary);
  }

  &.tertiary:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(primary-dark);
    box-shadow: none;
    color: _palette(primary-dark);
  }

  &.quaternary {
    background-color: _palette(bg-secondary);
    color: _palette(secondary);

    &.leftsplit:focus {
      background-color: _palette(bg-secondary);
      border: 0.125rem solid _palette(secondary);
      box-shadow:
        0 0 4px 0 rgba(15, 106, 136, 0.12),
        0 8px 8px 0 rgba(15, 106, 136, 0.24);
      outline: none;
    }

    &.leftsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(secondary);
      box-shadow: none;
      color: _palette(secondary);
    }

    &.rightsplit,
    &.rightsplitOpened {
      border-left: 0.0625rem solid _palette(secondary);
      border-radius: 0 3px 3px 0;
      min-width: 36.5px;
      outline: 0;
      padding-left: 0;
      padding-right: 0;
    }

    &.rightsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(secondary);
      box-shadow: none;
      color: _palette(secondary);
      outline: none;
    }

    &.rightsplit:focus {
      background-color: _palette(
        bg-secondary
      ); // Må endres når design er bestemt
      border: 0.125rem solid _palette(secondary);
      box-shadow:
        0 0 4px 0 rgba(15, 106, 136, 0.12),
        0 8px 8px 0 rgba(15, 106, 136, 0.24);
      outline: none;
    }

    &:hover {
      background-color: rgba(
        15,
        106,
        136,
        0.1
      ); // Må endres når design er bestemt
      color: _palette(secondary);
    }
  }

  &.quaternary:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(secondary);
    box-shadow:
      0 0 4px 0 rgba(15, 106, 136, 0.12),
      0 8px 8px 0 rgba(15, 106, 136, 0.24);
    color: _palette(secondary);
  }

  &.quaternary:disabled,
  &.quaternary[disabled] {
    background-color: _palette(bg-primary-dark);
    color: rgba(0, 0, 0, 0.5);
  }

  &.quaternary:disabled:hover,
  &.quaternary[disabled]:hover {
    background-color: #b0bdbd;
    color: _palette(bg-secondary);
  }

  &.quaternary:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(secondary);
    box-shadow: none;
    color: _palette(secondary);
  }

  &.quinary {
    background-color: _palette(bg-secondary);
    box-shadow:
      0 0 0.125rem 0 rgba(255, 0, 0, 1),
      0 0.125rem 0.125rem 0 rgba(128, 0, 0, 0.25);
    color: _palette(text-red);

    &.leftsplit:focus {
      background-color: _palette(bg-secondary);
      border: 0.125rem solid _palette(text-red);
      box-shadow:
        0 0 4px 0 rgba(15, 106, 136, 0.12),
        0 8px 8px 0 rgba(15, 106, 136, 0.24);
      outline: none;
    }

    &.leftsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(text-red);
      box-shadow: none;
      color: _palette(text-red);
    }

    &.rightsplit,
    &.rightsplitOpened {
      border-left: 0.0625rem solid _palette(text-red);
      border-radius: 0 3px 3px 0;
      min-width: 36.5px;
      outline: 0;
      padding-left: 0;
      padding-right: 0;
    }

    &.rightsplit:active {
      background-color: _palette(bg-secondary);
      border: 0.0625rem solid _palette(text-red);
      box-shadow: none;
      color: _palette(text-red);
      outline: none;
    }

    &.rightsplit:focus {
      background-color: _palette(
        bg-secondary
      ); // Må endres når design er bestemt
      border: 0.125rem solid _palette(text-red);
      box-shadow:
        0 0 4px 0 rgba(193, 66, 66, 0.12),
        0 8px 8px 0 rgba(193, 66, 66, 0.24);
      outline: none;
    }

    &:hover {
      background-color: rgba(
        193,
        66,
        66,
        0.1
      ); // Må endres når design er bestemt
      color: _palette(text-red);
    }
  }

  &.quinary:focus {
    background-color: _palette(bg-secondary);
    border: 0.125rem solid _palette(text-red);
    box-shadow:
      0 0 4px 0 rgba(193, 66, 66, 0.12),
      0 8px 8px 0 rgba(193, 66, 66, 0.24);
    color: _palette(text-red);
  }

  &.quinary:disabled,
  &.quinary[disabled] {
    background-color: _palette(bg-primary-dark);
    color: rgba(0, 0, 0, 0.5);
  }

  &.quinary:disabled:hover,
  &.quinary[disabled]:hover {
    background-color: #b0bdbd;
    color: _palette(bg-secondary);
  }

  &.quinary:active {
    background-color: _palette(bg-secondary);
    border: 0.0625rem solid _palette(text-red);
    box-shadow: none;
    color: _palette(text-red);
  }

  &.clearCloseRemove {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    padding: 0.1rem;
    border-radius: 5px;
    margin: 0 0.5rem;
    border: 0.1rem solid transparent;
    box-shadow: none;
    color: _palette(text-primary);
    cursor: pointer;
    height: fit-content;
    min-width: 0;
    outline: none;

    &:hover,
    &:focus {
      background-color: transparent;
      border-color: _palette(text-primary);
    }

    &:active {
      background-color: white;
      border: 0.1rem solid _palette(text-primary);
      color: _palette(text-primary);
      box-shadow:
        0 0 4px 0 rgba(114, 30, 127, 0.12),
        0 8px 8px 0 rgba(114, 30, 127, 0.24);
    }
  }
}

/* SplitButton */
.primarysplit {
  display: flex;
}

.dropdowncontainer {
  display: inline-block;
  position: relative;
}

.dropdownmenu {
  background-color: _palette(bg-secondary);
  border: 0.125rem solid _palette(primary);
  border-radius: 4px;
  box-shadow:
    0 0 1px 1px rgba(0, 0, 0, 0.02),
    0 4px 6px 1px rgba(0, 0, 0, 0.06);
  left: 0;
  margin-top: 0.125rem;
  position: absolute;
  right: 0;
  z-index: 10;

  &.secondary {
    border: 0.125rem solid _palette(secondary);
  }

  &.quaternary {
    border: 0.125rem solid _palette(secondary);
  }

  .dropdownitem {
    @include barlowMedium(14);
    height: 40px;
    padding: 5px;
    padding-bottom: 0;

    & > * {
      vertical-align: middle;
    }
  }

  .disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  .dropdownitem:hover {
    background-color: rgba(114, 30, 127, 0.1);
    cursor: pointer;
  }

  .dropdownitem:focus {
    background-color: rgba(114, 30, 127, 0.1);
    outline: none;
  }

  &.secondary .dropdownitem:hover {
    background-color: rgba(15, 106, 136, 0.1);
  }

  &.secondary .dropdownitem:focus {
    background-color: #80c0d5;
  }

  &.tertiary .dropdownitem:hover {
    background-color: rgba(114, 30, 127, 0.1);
  }

  &.tertiary .dropdownitem:focus {
    background-color: rgba(114, 30, 127, 0.1);
  }

  &.secondary .dropdownmenu {
    border: 0.125rem solid _palette(secondary);
  }

  &.quaternary .dropdownitem:hover {
    background-color: rgba(15, 106, 136, 0.1);
  }

  &.quaternary .dropdownitem:focus {
    background-color: rgba(15, 106, 136, 0.1);
  }
}

.addBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: fit-content;
  width: fit-content;

  .icon {
    margin-left: 0.25rem;
    pointer-events: none;
  }
}
